module.exports = __webpack_public_path__ + "static/img/minicon1.afabb94a.png";